import {
    FETCH_SUPPORT_DASHBOARD,
    FETCH_SUPPORT_DASHBOARD_SUCCESS,
    FETCH_SUPPORT_DASHBOARD_FAILURE,
    RESET_SUPPORT_DASHBOARD_LOADING,
} from "../actions/fetchSupportDashboardActions";

export const initialState = {
    loading: false,
    error: null,
    support_dashboard: null,
};

const supportDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SUPPORT_DASHBOARD:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_SUPPORT_DASHBOARD_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                support_dashboard: action.payload.data,
            };
        case FETCH_SUPPORT_DASHBOARD_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case RESET_SUPPORT_DASHBOARD_LOADING:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
};

export default supportDashboardReducer;
